export const ALLOWED_IBAN_COUNTRIES = ['BE', 'FR', 'DE', 'LU', 'NL']
